import { Component } from '@angular/core'

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  standalone: false,
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  public readonly anio = new Date().getFullYear()
}
